import { of } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { BaseDataSource, QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { KDDatHangService } from '../kd-dat-hang-service/kd-dat-hang.service';

export class KDDatHangDataSource extends BaseDataSource {
	constructor(private productsService: KDDatHangService) {
		super();
	}
	loadKDDatHangs(queryParams: QueryParamsModel) {
		this.productsService.lastFilter$.next(queryParams);
		this.productsService.lastFilterDN$.next(queryParams);
        this.loadingSubject.next(true);
		this.productsService.getData(queryParams)
			.pipe(
				tap(resultFromServer => {
					if (resultFromServer.data != null && resultFromServer.data != undefined) {
						this.entitySubject.next(resultFromServer.data);
						this.paginatorTotalSubject.next(resultFromServer.page.TotalCount);
					}
					else {
						this.entitySubject.next(null);
						this.paginatorTotalSubject.next(null);
					}
				}),
				catchError(err => of(new QueryResultsModel([], err))),
				finalize(() => this.loadingSubject.next(false))
			).subscribe();
	}
	loadDG(queryParams: QueryParamsModel) {
		this.productsService.lastFilter$.next(queryParams);
		this.productsService.lastFilterDN$.next(queryParams);
        this.loadingSubject.next(true);
		this.productsService.getDataDG(queryParams)
			.pipe(
				tap(resultFromServer => {
					if (resultFromServer.data != null && resultFromServer.data != undefined) {
						this.entitySubject.next(resultFromServer.data);
						this.paginatorTotalSubject.next(resultFromServer.page.TotalCount);
					}
					else {
						this.entitySubject.next(null);
						this.paginatorTotalSubject.next(null);
					}
				}),
				catchError(err => of(new QueryResultsModel([], err))),
				finalize(() => this.loadingSubject.next(false))
			).subscribe();
	}
	loadLS(queryParams: QueryParamsModel) {
		this.productsService.lastFilter$.next(queryParams);
		this.productsService.lastFilterDN$.next(queryParams);
        this.loadingSubject.next(true);
		this.productsService.getDataLS(queryParams)
			.pipe(
				tap(resultFromServer => {
					if (resultFromServer.data != null && resultFromServer.data != undefined) {
						this.entitySubject.next(resultFromServer.data);
						this.paginatorTotalSubject.next(resultFromServer.page.TotalCount);
					}
					else {
						this.entitySubject.next(null);
						this.paginatorTotalSubject.next(null);
					}
				}),
				catchError(err => of(new QueryResultsModel([], err))),
				finalize(() => this.loadingSubject.next(false))
			).subscribe();
	}
}
